import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import {
  EmailShareButton,
  FacebookMessengerShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebookMessenger,
  faXTwitter,
  faLinkedinIn,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import * as styles from './share.module.scss';
import { ShareQuery } from '../../../../graphql-types';
import { usePageContext } from '../../../hooks/contexts/usePageContext';

export const Share = () => {
  const { sanityTranslations } = useStaticQuery<ShareQuery>(QUERY);
  const { lang, defaultLang } = usePageContext();
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (window) setUrl(window.location.href);
  }, []);

  return (
    <div className={styles.wrapper}>
      <header>
        <h1 className={styles.title}>
          {sanityTranslations?._rawShareTitle?.[lang] ??
            sanityTranslations?._rawShareTitle?.[defaultLang]}
        </h1>
      </header>
      <div className={styles.line} />
      <ul className={styles.buttons}>
        <li className={styles.button}>
          <button
            name="share"
            className={styles.copy}
            type="button"
            onClick={() => navigator.clipboard.writeText(url)}
          >
            <FontAwesomeIcon className={styles.icon} icon={faCopy} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareCopy?.[lang] ??
                sanityTranslations?._rawShareCopy?.[defaultLang]}
            </span>
          </button>
        </li>
        <li className={styles.button}>
          <EmailShareButton url={url}>
            <FontAwesomeIcon className={styles.icon} icon={faEnvelope} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareEmail?.[lang] ??
                sanityTranslations?._rawShareEmail?.[defaultLang]}
            </span>
          </EmailShareButton>
        </li>
        <li className={styles.button}>
          <FacebookMessengerShareButton appId="210" url={url}>
            <FontAwesomeIcon className={styles.icon} icon={faFacebookMessenger} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareMessenger?.[lang] ??
                sanityTranslations?._rawShareMessenger?.[defaultLang]}
            </span>
          </FacebookMessengerShareButton>
        </li>
        <li className={styles.button}>
          <TwitterShareButton url={url}>
            <FontAwesomeIcon className={styles.icon} icon={faXTwitter} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareTwitter?.[lang] ??
                sanityTranslations?._rawShareTwitter?.[defaultLang]}
            </span>
          </TwitterShareButton>
        </li>
        <li className={styles.button}>
          <LinkedinShareButton url={url}>
            <FontAwesomeIcon className={styles.icon} icon={faLinkedinIn} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareLinkedin?.[lang] ??
                sanityTranslations?._rawShareLinkedin?.[defaultLang]}
            </span>
          </LinkedinShareButton>
        </li>
        <li className={styles.button}>
          <WhatsappShareButton url={url}>
            <FontAwesomeIcon className={styles.icon} icon={faWhatsapp} />
            <span className={styles.label}>
              {sanityTranslations?._rawShareWhatsapp?.[lang] ??
                sanityTranslations?._rawShareWhatsapp?.[defaultLang]}
            </span>
          </WhatsappShareButton>
        </li>
      </ul>
    </div>
  );
};

const QUERY = graphql`
  query share {
    sanityTranslations {
      _rawShareTitle
      _rawShareTwitter
      _rawShareWhatsapp
      _rawShareMessenger
      _rawShareLinkedin
      _rawShareEmail
      _rawShareCopy
    }
  }
`;
